import styles from '@salesforce/retail-react-app/app/theme/components/project/social-icons';

export default {
  ...styles,

  baseStyle: {
    ...styles.baseStyle,

    container: {
      ...styles.baseStyle.container,

      gap: '16px',
    },
    icon: {},
    item: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '20px',
      minWidth: 'auto',
      padding: 0,
      textAlign: 'center',
      flex: '0 0 auto',
      width: '20px',
      _hover: {
        color: 'whiteAlpha.800',
        transform: 'scale(1.1)',
      },
      _active: {
        transform: 'scale(0.95)',
      },
      transition: 'all 0.2s ease-in-out',
      sx: {
        '&': {
          flex: '0 0 auto',
        },
      },
    },
  },
};
